import { useHasSharingPermissions } from '@/modules/settings/hooks';

import { isPublicSharingActive } from '../../../utilities';
import { useSecretDetailContext } from '../SecretDetailProvider';

export const useIsPublicSharingActiveWithPermissions = () => {
    const { share, userPermissions } = useSecretDetailContext();
    const { getHasSharingPermissions } = useHasSharingPermissions();

    const isSharingActive = isPublicSharingActive(share);
    const hasSharingPermissions = getHasSharingPermissions(userPermissions);

    return isSharingActive && hasSharingPermissions;
};
